import { getBrowserAuthoringNormalizers } from "./browser-authoring-normalizers"

const browserNormalizers = getBrowserAuthoringNormalizers()

export const { stripAuthoringComparisonArtifacts } = browserNormalizers
export const { normalizeAuthoringComparisonText } = browserNormalizers
export const { normalizeAuthoringPlainText } = browserNormalizers
export const { normalizeAuthoringSnapshotHtml } = browserNormalizers
export const { normalizeAuthoringStructuralHtml } = browserNormalizers
export const { normalizeAuthoringComparisonDiffHtml } = browserNormalizers
